import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom'; 
import type { GetExpertsFilterParams } from '../../api/expert-list.api';

export const useExpertFilters = (fixedCategory: string) => {
  const [searchParams] = useSearchParams();

  // Initialize from URL
  const [subCategory, setSubCategory] = useState<string | undefined>(
    searchParams.get('subCategory') || undefined
  );

  // 🟢 THE FIX: Listen for URL changes. If the user clicks a main tab and the 
  // query parameter disappears from the URL, clear the subCategory state automatically.
  useEffect(() => {
    const urlSubCategory = searchParams.get('subCategory');
    setSubCategory(urlSubCategory || undefined);
  }, [searchParams]);

  const [searchTerm, setSearchTerm] = useState('');
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
  
  const [sortBy, setSortBy] = useState<'price' | 'rating' | 'experience' | undefined>();
  const [sortOrder, setSortOrder] = useState<'ASC' | 'DESC' | undefined>();
  const [minRating, setMinRating] = useState<number | undefined>();

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);
    return () => clearTimeout(handler);
  }, [searchTerm]);

  const filters: GetExpertsFilterParams = {
    search: debouncedSearchTerm,
    category: fixedCategory,
    ...(subCategory && { subCategory }), 
    ...(sortBy && { sortBy }),
    ...(sortOrder && { sortOrder }),
    ...(minRating && { minRating }),
  };

  return {
    searchTerm,
    setSearchTerm,
    subCategory,
    setSubCategory,
    sortBy,
    setSortBy,
    sortOrder,
    setSortOrder,
    minRating,
    setMinRating,
    filters 
  };
};